/**
 * MemoryFactCard — the fact text with inline edit. Demo page: /file-manager detail pane; form fields from /form-layouts.
 */
import React from 'react';
import { Form, FormActions, TextAreaFormField, useZodForm } from '../../../components/form/index.js';
import { Card } from '../../../components/ui/index.js';
import { zMemoryUpdate } from '../../../generated/api/zod.gen.js';

interface MemoryFactCardProps {
  factText: string;
  editing: boolean;
  onCancel: () => void;
  /** Throws on failure so the form shows the server's message. */
  onSave: (factText: string) => Promise<unknown>;
}

export const MemoryFactCard: React.FC<MemoryFactCardProps> = ({ factText, editing, onCancel, onSave }) => {
  const form = useZodForm(zMemoryUpdate, { defaultValues: { factText } });

  if (!editing) {
    return (
      <Card title="Fact">
        <p className="whitespace-pre-wrap text-sm leading-relaxed text-body">{factText}</p>
      </Card>
    );
  }

  return (
    <Card title="Edit fact">
      <Form form={form} onSubmit={(values) => onSave(values.factText)} guardUnsaved>
        <TextAreaFormField name="factText" label="Fact" required rows={6} />
        <FormActions submitLabel="Save changes" onCancel={onCancel} />
      </Form>
    </Card>
  );
};
